import { forwardRef, type SVGProps } from "react";

/**
 * OnaLettermark is the icon containing only the "O" from the ONA logo (for that, consult OnaWordmark.tsx).
 * I felt like calling it a "lettermark" was funny, but as an FYI, it's not a real word.
 */
export const OnaLettermark = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({ ...props }, ref) => (
    <svg
        width="32"
        height="33"
        viewBox="0 0 32 33"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
    >
        <path d="M30.9471 9.86238C31.588 10.5033 32 11.3731 32 12.3803V20.6664C32 21.6735 31.588 22.5434 30.9471 23.1843L22.6609 31.4704C22.02 32.1571 21.1044 32.5233 20.1431 32.5233H11.8569C10.8498 32.5233 9.97997 32.1571 9.29328 31.4704L1.00715 23.1843C0.366237 22.5434 0 21.6735 0 20.6664V12.3803C0 11.3731 0.366237 10.5033 1.00715 9.8166L9.29328 1.53047C9.97997 0.889556 10.8498 0.477539 11.8569 0.477539H20.1431C21.1044 0.477539 22.02 0.889557 22.6609 1.57625L30.9471 9.86238ZM24.4101 21.3626V11.6841C24.4101 9.71554 22.8078 8.06747 20.8393 8.06747H11.1607C9.14644 8.06747 7.54415 9.71554 7.54415 11.6841V21.3626C7.54415 23.3311 9.14644 24.9334 11.1607 24.9334H20.8393C22.8078 24.9334 24.4101 23.3311 24.4101 21.3626Z" />
    </svg>
));

OnaLettermark.displayName = "OnaWordmark";
